import { useState } from 'react';
import CustomDialog from '../../../../components/stateless/dialog/CustomDialog';
import TextField from '../../../../components/stateful/textField/TextField';
import { Title } from '../../../../utilities/interfaces/Title';
import { Agency } from '../../../../utilities/interfaces/Agency';
import { useNotificationHelper } from '../../../../utilities/helpers/NotificationHelper';
import { titleAPI } from '../../../../utilities/api';

type Props = { agency: Agency; open: boolean; closeDialog: () => void };

export const AddTitleDialog = (props: Props) => {
  const { agency, open, closeDialog } = props;
  const [titleName, setTitleName] = useState<string>('');
  const [titleNumber, setTitleNumber] = useState<number>(-1);
  const { addNotification } = useNotificationHelper();

  const handleTitleNumberChange = (number: number) => {
    setTitleNumber(number);
  };

  const handleTitleNameChange = (name: string) => {
    setTitleName(name);
  };

  const approve = async () => {
    if (agency.id) {
      const title: Title = {
        titleName: titleName,
        titleNumber: titleNumber,
        agencyId: agency.id,
      };
      await titleAPI
        .createTitle(title)
        .then(() => {
          closeDialog();
          addNotification({
            type: 'success',
            message: `${agency.agencyName} saved successfully.`,
          });
        })
        .catch((error: any) => {
          addNotification({
            type: 'error',
            message: `${title.titleName} was unable to save.`,
          });
        });
    } else {
      addNotification({
        type: 'error',
        message: `Could not find the selected agency`,
      });
    }
  };

  return (
    <>
      {open ? (
        //#region dialog
        <CustomDialog
          open={open}
          title={'Create Title'}
          toggleDialog={closeDialog}
          approveAction={approve}
          cancelAction={closeDialog}
        >
          <div className="code-textfield">
            <TextField
              onChange={() => {
                console.error('Cannot edit selected agency');
              }}
              title={'Agency Name'}
              value={agency.agencyName}
              fullwidth
              readOnly
            />
            <TextField
              onChange={(value: number) => {
                handleTitleNumberChange(value);
              }}
              title={'Title Number'}
              fullwidth
              numeric
            />
            <TextField
              onChange={(value: string) => {
                handleTitleNameChange(value);
              }}
              title={'Title Name'}
              fullwidth
            />
          </div>
        </CustomDialog>
      ) : //#endregion
      null}
    </>
  );
};
